// extracted by mini-css-extract-plugin
export default {"root":"CreateAlbum__root--3EQtO","disabled":"CreateAlbum__disabled--32Q2W","addIcon":"CreateAlbum__addIcon--FL76v","lockIcon":"CreateAlbum__lockIcon--3KvbZ"};